import {lazy} from 'react';

const TaxesTouristViewAsync = lazy(() => import('./TaxesTouristView'));

export {TaxesTouristViewAsync};
